import { QueryHookOptions, gql } from '@apollo/client'
import { LinkOnlyRedemptionBlockFragment, MultipleCodesRedemptionBlockFragment, Redemption, SingleCodeRedemptionBlockFragment } from 'app/features/offer/redemptions'
import { usePersistedCacheQuery } from 'app/hooks'

export const fetchCategoryOffersQuery = gql`
  query fetchCategoryOffers($category: String!, $page: Int!, $limit: Int!) {
    fetchOffers(category: $category, page: $page, limit: $limit) {
      totalDocs
      page
      totalPages
      docs {
        id
        name
        description
        tag
        brand {
          id
          name
          slug
          logo {
            id
            url
            alt
          }
        }
        thumbnailImage {
          id
          url
          alt
        }
        slug
        redeemInList
        canRedeem
        offerLinkLabel
        redemptions {
          ${LinkOnlyRedemptionBlockFragment.partialFragment}
          ${MultipleCodesRedemptionBlockFragment.partialFragment}
          ${SingleCodeRedemptionBlockFragment.partialFragment}
        }
      }
    }
  }
`

export interface CategoryOffersQueryInput {
  category: string
  page: number
  limit: number
}

export interface CategoryOffersQueryOutput {
  fetchOffers: {
    totalDocs: number
    page: number
    totalPages: number
    docs: {
      id: string
      name: string
      description: string
      tag: string
      brand: {
        id: string
        name: string
        slug: string
        logo: {
          url: string
        }
      }
      thumbnailImage: {
        url: string
      }
      slug: string
      redeemInList: boolean
      canRedeem: boolean
      offerLinkLabel: string
      redemptions: Redemption[]
    }[]
  }
}

export const useCategoryOffersQuery = (
  options?: QueryHookOptions<CategoryOffersQueryOutput, CategoryOffersQueryInput>
) =>
  usePersistedCacheQuery<CategoryOffersQueryOutput, CategoryOffersQueryInput>(fetchCategoryOffersQuery, {
    ...options,
  })
